// Action creators extracted from NavigationModule.js

import { UPDATE_NAVIGATION_OBJECT } from "./NavigationConstants";

// Action Creators
export const updateNavigationObject = data => {
  return { type: UPDATE_NAVIGATION_OBJECT, data };
};
